import { render, staticRenderFns } from "./MobileValue.vue?vue&type=template&id=358fc760&scoped=true&"
import script from "./MobileValue.vue?vue&type=script&lang=js&"
export * from "./MobileValue.vue?vue&type=script&lang=js&"
import style0 from "./MobileValue.vue?vue&type=style&index=0&id=358fc760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358fc760",
  null
  
)

export default component.exports